import React from 'react';
import { Container } from 'react-bootstrap'
import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Layout
import Layout from './layout/Layout'

// pages
import Home from './pages/Home'
import NotFound from './pages/NotFound'
import Listings from './pages/listings/Listings';
import Solution from './pages/solutions/Solution';
import Play from './pages/testpage';


const App = () => {
  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Project Sigma</title>
        <meta name="description" content="Project Sigma is a website that presents solutions, interactively, for Project Euler Problems." />
      </Helmet>
      <Container>
        <Switch>
          <Route path='/' component={Home} exact />
          <Route path='/solutions/problem/:id' component={Solution} />
          <Route path='/solutions/:id' component={Listings} />
          <Route path='/testpage' component={Play} />
          <Route component={NotFound} />
        </Switch>
      </Container>
    </Layout>
  )
}

export default App
